var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiservLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-35.87625 -30.03075 310.9275 180.1845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v792H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v792H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h612v792H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f60"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(5.62504 0 0 -5.62503 -334.843 1311.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.471 226.975a.266.266 0 00-.27-.27.265.265 0 00-.27.27c0 .154.116.27.27.27.152 0 .27-.116.27-.27m.052 0a.316.316 0 01-.322.322.315.315 0 01-.323-.322c0-.183.14-.322.323-.322.181 0 .322.139.322.322m-.176.076c0 .073-.052.106-.115.106h-.154v-.352h.06v.136h.067l.07-.136h.07l-.07.142c.043.014.072.048.072.104m-.06-.002c0-.034-.024-.05-.057-.05h-.092v.1h.092c.033 0 .057-.017.057-.05"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.175 103.795h-15.266v15.272h15.266zM192.93 35.798l9.096 68.254 9.078-68.254h14.17l-13.253 83.267h-20.149L178.76 35.798z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(5.62504 0 0 -5.62503 -334.843 1311.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.924 226.747h-1.397v-1.967h1.397v-12.836h2.455v12.836h1.725v1.967H63.38v3.01c0 .438.091.774.303 1.004.213.228.538.336.98.336h.441v2.014h-.888c-1.09 0-2.142-.23-2.642-.706-.5-.475-.649-1.212-.649-2.262z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.684 119.061h13.843V35.794H35.684z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(5.62504 0 0 -5.62503 -334.843 1311.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.695 218.508h5.13v4.562c-.006 2.73-1.318 3.848-3.804 3.848-2.585 0-3.797-1.116-3.797-3.866v-7.497c.008-2.5 1.522-3.795 3.796-3.795 2.273 0 3.799 1.065 3.805 3.795v1.186h-2.377l.003-1.405c0-1.002-.375-1.695-1.381-1.695-1.008 0-1.375.7-1.375 1.696zm0 5.053c0 .835.217 1.7 1.368 1.7 1.15 0 1.383-.852 1.383-1.699v-3.059h-2.751zm-5.83-3.201c-1.867 1.621-2.012 1.856-2.012 3.064 0 1.03.09 1.655 1.014 1.655s1.044-.618 1.044-1.667v-1.367h2.372v2.23c-.008 1.751-1.355 2.641-3.47 2.641-2.082 0-3.439-.693-3.45-3.492-.003-.476 0-.476 0-.292.003-.88.007-2.275 2.182-4.14l.624-.535c1.603-1.352 1.778-1.515 1.771-3.123 0-.99-.062-1.742-1.102-1.742s-1.105.757-1.105 1.224v1.894h-2.49v-1.954c0-2.405 1.565-3 3.592-3 2.03 0 3.596.601 3.596 3.695v.257c-.005 2.162-.396 2.742-2.566 4.652m14.254 4.864v1.524h-2.243v-14.802h2.42v10.316c-.001.797.259 1.322.71 1.632.429.295.956.395 1.627.405v2.619c-1.284-.027-1.838-.28-2.49-1.64z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiservLogo);
export default __webpack_public_path__ + "static/media/fiserv-logo.3d7edd984ccc9830ed417ffd4556e4dc.svg";
export { ForwardRef as ReactComponent };